var slideBasic = new Swiper(".slide_basic_wrap .swiper", {
    loop: true,
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 0,
    navigation: {
        nextEl: '.slide_basic_wrap .swiper-button-next',
        prevEl: '.slide_basic_wrap .swiper-button-prev',
    },
    pagination: {
        el: ".slide_basic_wrap .swiper-pagination",
        type: 'bullets',
        clickable: true,
    },
});